import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Address } from 'components/forms'
import { Input, InputPhone, Radio, RadioGroup, Select } from 'components/fields'
import { Button, FormDebug } from 'components/misc'
import { wizard, meta } from 'helpers/decorators'
import { apiCodeLists, apiCommon, apiConfiguration } from 'helpers/decorators/api'
import validate from './award-unit-details.validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { awardUnit } from 'constants/wizards'

@apiCodeLists(['organizationTypes'], {
  public: true
})
@apiConfiguration()
@apiCommon({
  publicCountries: true
})
@wizard({
  form: 'awardUnitRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate
})
@meta({
  title: 'Organisation Details',
  intlKey: 'moduleTitle.organisation_details'
})
class AwardUnitDetails extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    common: PropTypes.object.isRequired,
    values: PropTypes.object,
    errors: PropTypes.object,
    codeLists: PropTypes.object,
    onGetConfigurationValue: PropTypes.func.isRequired,
    changeWizardNext: PropTypes.func.isRequired,
    changeWizardActive: PropTypes.func.isRequired
  }

  componentDidMount = async() => {
    const { steps, rootPath } = awardUnit

    const organizationId = this.getOrganizationId(this.props.values.helpers)

    const authContactIsEnabledCfg = await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.authContactIsEnabled.id, organizationId)

    const authContactIsEnabled = get(authContactIsEnabledCfg, 'body.booleanValue', false)

    if(!authContactIsEnabled){
      this.props.changeWizardActive(
        steps.authorisingContact.id,
        authContactIsEnabled
      )

      this.props.changeWizardNext(
        steps.details.id,
        rootPath + steps.leader.path
      )
      return
    }


  }

  getOrganizationId = helpers => {
    return get(helpers, 'selectedSoa.id') ||
      get(helpers, 'selectedOa.id') ||
      get(helpers, 'selectedCountry.naoId')
  }

  render() {
    const {
      handleSubmit,
      onSubmit,
      values,
      errors,
      codeLists,
      selectedCountryIcoCode,
      common
    } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1 className="alpha">
          <FormattedMessage
            id="moduleTitle.organisation_details"
            defaultMessage="Organisation Details"
          />
        </h1>

        <div className="row">
          <div className="col-xs-12 col-xs-6 col-md-4">
            <Input
              intlKey="label.organisation_name"
              label="Organisation name"
              name="organizationName"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-xs-6 col-md-4">
            <Select
              intlKey="label.organisation_type"
              label="Organisation type"
              name="organizationType.value"
              options={get(codeLists, 'organizationTypes.list')}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-xs-6 col-md-4">
            <RadioGroup
              {...this.props}
              label="Are you already running the Award?"
              intlKey="label.are_you_already_running_award"
              name="isAlreadyRunningAward"
            >
              <Radio
                label="Yes"
                intlKey="label.yes"
                name="isAlreadyRunningAward"
                value="yes"
              />
              <Radio
                label="No"
                intlKey="label.no"
                name="isAlreadyRunningAward"
                value="no"
              />
            </RadioGroup>
          </div>
        </div>

        <h2 className="beta">
          <FormattedMessage
            id="moduleTitle.organisation_contact"
            defaultMessage="Organisation Contact"
          />
        </h2>
        <div className="row">


          <div className="col-xs-12 col-sm-6 col-md-4">
            <InputPhone
              name="organizationPhoneNumber"
              label="Phone number"
              intlKey="label.phone_number"
              selectedCountryIcoCode={selectedCountryIcoCode}
            />
          </div>
        </div>


        <h2 className="beta">
          <FormattedMessage
            id="moduleTitle.organisation_address"
            defaultMessage="Organisation Address"
          />
        </h2>

        <Address countries={common.countries.list} />



        <FormDebug values={values} errors={errors} />
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
    )
  }
}

export default AwardUnitDetails
